"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 56",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27,
    cy: 27.023,
    rx: 27,
    ry: 27.023,
    transform: "translate(0 .291)",
    fill: "#CF703E"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.552 11.508c-4.532 0-8.813 2.203-11.668 5.756v-1.028c0-.516-.4-.933-.893-.933-.494 0-.893.417-.893.933v3.963c0 .89 1.1 1.018.893.933.018 0 .036 0 .055-.002l3.572-.231c.492-.032.867-.475.836-.989-.03-.514-.46-.9-.946-.874l-1.81.118c2.507-3.562 6.562-5.78 10.854-5.78 7.386 0 13.454 6.34 13.454 14.058 0 .516.4.933.893.933.494 0 .893-.417.893-.933 0-8.746-6.869-15.924-15.24-15.924zM39.973 32.478l-3.572.231c-.493.032-.867.475-.836.989.03.514.47.906.946.874l1.81-.118c-2.507 3.562-6.562 5.78-10.854 5.78-7.387 0-13.455-6.34-13.455-14.058 0-.515-.399-.933-.893-.933-.493 0-.893.418-.893.933 0 8.746 6.87 15.924 15.24 15.924 4.533 0 8.814-2.202 11.67-5.756v1.029c0 .515.398.933.892.933s.893-.418.893-.933v-3.964c0-.512-.47-.96-.948-.931z"
  }))));
}

var _default = SvgUpdate;
exports.default = _default;